import React, {Fragment, useRef, useState} from 'react';
import {Controller, useForm} from "react-hook-form";
import {useSelector} from "react-redux";
import {selectLang} from "../../../store/reducers/main/main";
import {Translate} from "../../../lang/lang";
import EventBus from "../../../eventbus/EventBus";
import {BULK_EDIT_ITEMS_FINISHED, BULK_EDIT_ITEMS_STARTED} from "../../../eventbus/itemEvents";
import {editItemAsync} from "../../../store/reducers/item/itemReducer";
import ResultCounter from "./ResultCounter";
import IconButton from "../../IconButton";
import {faListCheck} from "@fortawesome/free-solid-svg-icons";
import {Form, Modal} from "react-bootstrap";
import Button from "../../common/Button";
import classNames from "classnames";
import ItemLegalTypeSelect from "./ItemLegalTypeSelect";

const BulkEditItemLegalType = ({items}) => {
    const [show, setShow] = useState(false);
    const {handleSubmit, control, reset, formState: {errors}} = useForm({
        defaultValues: {
            legalType: null,
        }
    })
    const lang = useSelector(selectLang);
    const ref = useRef(null);
    const t = Translate;

    const handleShow = () => setShow(true);
    const handleClose = () => {
        reset();
        setShow(false);
    };

    const onSubmit = async ({legalType}) => {
        handleClose();

        ref.current.updateLoadedCount(items.length);
        EventBus.dispatch(BULK_EDIT_ITEMS_STARTED);
        for (let i = 0; i < items.length; i++) {
            try {
                const {item} = items[i];
                const itemJson = {
                    ...item,
                    measurement: item.measurement.toString(),
                    legal_type: legalType,
                }
                await editItemAsync(item.id, itemJson);
                ref.current.incrementSucceedCount();
            } catch (e) {
                console.log(e);
                ref.current.incrementFailedCount();
            }
        }
        EventBus.dispatch(BULK_EDIT_ITEMS_FINISHED);
    }

    return (
        <Fragment>
            <ResultCounter ref={ref}/>
            <span onClick={handleShow}>{t(lang, 'items.common.bulk_edit_item_legal_type')}</span>
            <Modal show={show} onHide={handleClose}>
                <Form onSubmit={handleSubmit(onSubmit)}>
                    <Modal.Header>
                        <Modal.Title>{t(lang, 'items.common.bulk_edit_item_legal_type')}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form.Group>
                            <Controller
                                control={control}
                                name={'legalType'}
                                rules={{required: t(lang, "edi.common.forms.validations.is_required")}}
                                render={({field}) => (
                                    <ItemLegalTypeSelect
                                        id={'legalType'}
                                        placeholder={t(lang, 'items.common.bulk_edit_item_legal_type')}
                                        legalType={field.value}
                                        onChange={field.onChange}
                                        selectorProps={{
                                            className: classNames({'is-invalid': errors?.legalType}),
                                            wrapperClassName: classNames({'is-invalid': errors?.legalType}),
                                        }}
                                    />
                                )}
                            />
                            <Form.Control.Feedback type={'invalid'}>
                                {errors?.legalType?.message}
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant={'secondary'} onClick={handleClose}>{t(lang, 'main.common.back')}</Button>
                        <Button variant={'primary'} type={'submit'}>{t(lang, 'edi.common.button.save')}</Button>
                    </Modal.Footer>
                </Form>
            </Modal>
        </Fragment>
    );
};

export default BulkEditItemLegalType;
